// src/DeleteCredentialConfirmModal.js
import React from "react";
import "../../../DeleteCredentialConfirmModal.css";

const DeleteCredentialConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  credentialId,
  patronName,
  deviceName,
  isDeleting,
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <>
      <div className="delete-cred-modal-overlay" onClick={onClose} />
      <div className="delete-cred-modal">
        <h2>🗑️ Remove Credential from Device</h2>
        <div className="delete-cred-modal-content">
          <p className="delete-cred-warning">
            Are you sure you want to remove this credential from{" "}
            <strong>{deviceName}</strong>?
          </p>

          <div className="delete-cred-details">
            {patronName && (
              <p>
                <strong>User:</strong> {patronName}
              </p>
            )}
            <p className="delete-cred-id">
              <strong>Credential ID:</strong> {credentialId}
            </p>
          </div>

          <div className="delete-cred-notice">
            <p>⚠️ This will only remove the credential from this device.</p>
            <p>The credential will remain active on other devices.</p>
          </div>
        </div>

        <div className="delete-cred-modal-actions">
          <button
            className="delete-cred-cancel-btn"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            className="delete-cred-confirm-btn"
            onClick={handleConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "Removing..." : "Remove Credential"}
          </button>
        </div>
      </div>
    </>
  );
};

export default DeleteCredentialConfirmModal;
